// extracted by mini-css-extract-plugin
export default {"Strip":"RegularAppletsWidget_Strip__b1zOp"};